// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as ShippingPolicyRouteImport } from './routes/shipping-policy'
import { Route as SentryTestRouteImport } from './routes/sentry-test'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ReferRouteImport } from './routes/refer'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PitchRouteImport } from './routes/pitch'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvestorRouteImport } from './routes/investor'
import { Route as GrantsRouteImport } from './routes/grants'
import { Route as ForInvestorsRouteImport } from './routes/for-investors'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ApplySuccessRouteImport } from './routes/apply-success'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as HandleRouteImport } from './routes/$handle'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks.index'
import { Route as TasksSubmissionIdRouteImport } from './routes/tasks.$submissionId'
import { Route as InvestorIndexRouteImport } from './routes/investor.index'
import { Route as InvestorShareRouteImport } from './routes/investor.share'
import { Route as InvestorProfileRouteImport } from './routes/investor.profile'
import { Route as InvestorDealsRouteImport } from './routes/investor.deals'
import { Route as GrantsIndexRouteImport } from './routes/grants.index'
import { Route as GrantsProfileRouteImport } from './routes/grants.profile'
import { Route as GrantsExtensionRouteImport } from './routes/grants.extension'
import { Route as GrantsIdRouteImport } from './routes/grants.$id'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminTeamRouteImport } from './routes/admin.team'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin.subscriptions'
import { Route as AdminProgramsRouteImport } from './routes/admin.programs'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminGrantsRouteImport } from './routes/admin.grants'
import { Route as AdminAnalysesRouteImport } from './routes/admin.analyses'
import { Route as AdminAffiliatesRouteImport } from './routes/admin.affiliates'
import { Route as InvestorReferralsDeckIdRouteImport } from './routes/investor.referrals.$deckId'

const UploadRoute = UploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const TasksRoute = TasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => rootRouteImport
          })
const ShippingPolicyRoute = ShippingPolicyRouteImport.update({
            id: '/shipping-policy',path: '/shipping-policy',getParentRoute: () => rootRouteImport
          })
const SentryTestRoute = SentryTestRouteImport.update({
            id: '/sentry-test',path: '/sentry-test',getParentRoute: () => rootRouteImport
          })
const ResultsRoute = ResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ReferRoute = ReferRouteImport.update({
            id: '/refer',path: '/refer',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PitchRoute = PitchRouteImport.update({
            id: '/pitch',path: '/pitch',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const InvestorRoute = InvestorRouteImport.update({
            id: '/investor',path: '/investor',getParentRoute: () => rootRouteImport
          })
const GrantsRoute = GrantsRouteImport.update({
            id: '/grants',path: '/grants',getParentRoute: () => rootRouteImport
          })
const ForInvestorsRoute = ForInvestorsRouteImport.update({
            id: '/for-investors',path: '/for-investors',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ApplySuccessRoute = ApplySuccessRouteImport.update({
            id: '/apply-success',path: '/apply-success',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const HandleRoute = HandleRouteImport.update({
            id: '/$handle',path: '/$handle',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TasksIndexRoute = TasksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TasksRoute
          })
const TasksSubmissionIdRoute = TasksSubmissionIdRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => TasksRoute
          })
const InvestorIndexRoute = InvestorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InvestorRoute
          })
const InvestorShareRoute = InvestorShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => InvestorRoute
          })
const InvestorProfileRoute = InvestorProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => InvestorRoute
          })
const InvestorDealsRoute = InvestorDealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => InvestorRoute
          })
const GrantsIndexRoute = GrantsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GrantsRoute
          })
const GrantsProfileRoute = GrantsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => GrantsRoute
          })
const GrantsExtensionRoute = GrantsExtensionRouteImport.update({
            id: '/extension',path: '/extension',getParentRoute: () => GrantsRoute
          })
const GrantsIdRoute = GrantsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => GrantsRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminTeamRoute = AdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AdminRoute
          })
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AdminRoute
          })
const AdminProgramsRoute = AdminProgramsRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AdminRoute
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminRoute
          })
const AdminGrantsRoute = AdminGrantsRouteImport.update({
            id: '/grants',path: '/grants',getParentRoute: () => AdminRoute
          })
const AdminAnalysesRoute = AdminAnalysesRouteImport.update({
            id: '/analyses',path: '/analyses',getParentRoute: () => AdminRoute
          })
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => AdminRoute
          })
const InvestorReferralsDeckIdRoute = InvestorReferralsDeckIdRouteImport.update({
            id: '/referrals/$deckId',path: '/referrals/$deckId',getParentRoute: () => InvestorRoute
          })





const AdminRouteChildren = {
  AdminAffiliatesRoute: AdminAffiliatesRoute,AdminAnalysesRoute: AdminAnalysesRoute,AdminGrantsRoute: AdminGrantsRoute,AdminOrdersRoute: AdminOrdersRoute,AdminProgramsRoute: AdminProgramsRoute,AdminSubscriptionsRoute: AdminSubscriptionsRoute,AdminTeamRoute: AdminTeamRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const GrantsRouteChildren = {
  GrantsIdRoute: GrantsIdRoute,GrantsExtensionRoute: GrantsExtensionRoute,GrantsProfileRoute: GrantsProfileRoute,GrantsIndexRoute: GrantsIndexRoute
}

const GrantsRouteWithChildren = GrantsRoute._addFileChildren(GrantsRouteChildren)




const InvestorRouteChildren = {
  InvestorDealsRoute: InvestorDealsRoute,InvestorProfileRoute: InvestorProfileRoute,InvestorShareRoute: InvestorShareRoute,InvestorIndexRoute: InvestorIndexRoute,InvestorReferralsDeckIdRoute: InvestorReferralsDeckIdRoute
}

const InvestorRouteWithChildren = InvestorRoute._addFileChildren(InvestorRouteChildren)




const TasksRouteChildren = {
  TasksSubmissionIdRoute: TasksSubmissionIdRoute,TasksIndexRoute: TasksIndexRoute
}

const TasksRouteWithChildren = TasksRoute._addFileChildren(TasksRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,HandleRoute: HandleRoute,AdminRoute: AdminRouteWithChildren,AnalyticsRoute: AnalyticsRoute,ApplyRoute: ApplyRoute,ApplySuccessRoute: ApplySuccessRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,ForInvestorsRoute: ForInvestorsRoute,GrantsRoute: GrantsRouteWithChildren,InvestorRoute: InvestorRouteWithChildren,LoginRoute: LoginRoute,PitchRoute: PitchRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ReferRoute: ReferRoute,RefundPolicyRoute: RefundPolicyRoute,ResultsRoute: ResultsRoute,SentryTestRoute: SentryTestRoute,ShippingPolicyRoute: ShippingPolicyRoute,TasksRoute: TasksRouteWithChildren,TermsAndConditionsRoute: TermsAndConditionsRoute,UploadRoute: UploadRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)